import vSelect from 'vue-select';
import autoApi from '../../../services/auto.api';
import jwt from 'jsonwebtoken';
import { DOCUMENT_MASK } from '../../../constants/cpfCnpj';

export default {
  props: ['filters', 'completePermission', 'showFilterBroker'],
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      DOCUMENT_MASK,
      brokers: [],
      currentUser: null,
      localFilters: {},
      dueDaysOptions: Array.from({ length: 10 }, (_, i) => i + 1),
      error: false,
    };
  },
  async mounted() {
    this.getDecoded();

    if (this.completePermission) {
      await this.getBrokersList();
    } else {
      await this.getAccessibleBrokers();
    }
  },
  watch: {
    filters() {
      this.localFilters = this.filters;
    },
  },
  methods: {
    setBrokersSelect(brokers) {
      this.brokers = brokers.sort((firstBroker, secondBroker) =>
        firstBroker.label.localeCompare(secondBroker.label),
      );

      if (!this.showFilterBroker && brokers.length) {
        this.localFilters.brokerId = brokers[0].id;
        this.applyFilters();
        return;
      }

      if (brokers.length <= 1) return;
      this.brokers.unshift({ label: 'Todas as corretoras', id: -1 });
    },
    removeFilters() {
      this.$emit('removeFilters');
    },
    applyFilters() {
      if (this.localFilters.brokerId) {
        this.error = false;
        this.$emit('applyFilters', this.localFilters);
        return;
      }
      this.error = true;
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.currentUser = jwt.decode(token);
      }
    },
    getBrokersList() {
      autoApi
        .getBrokersList()
        .then((res) => {
          this.setBrokersSelect(res);
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar as corretoras',
            color: 'danger',
          });
        });
    },
    getAccessibleBrokers() {
      autoApi
        .getAccessibleBrokers()
        .then((res) => {
          this.setBrokersSelect(res);
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro ao buscar as corretoras',
            color: 'danger',
          });
        });
    },
  },
};
